<template>
	<section class="c-team">
		<div class="container">
			<ul class="c-team__list">
				<li class="c-team__list-item"
					v-for="member in team">
					<div class="c-team__member-image">
						<img :src="member.image.sizes.large" :alt="member.name">
					</div>

					<h3 class="c-team__member-title">
						{{ member.name }}
					</h3>
					<p class="c-team__member-desc">
						{{ member.description }}
					</p>
					<a v-if="member.email" class="c-team__member-email" :href="'mailto:' + member.email">{{ member.email }}</a>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
export default {
	name: 'team',
	props: ['team'],
	data: () => ({
	})
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	$m: 'c-team';

	.#{$m} {
		padding: 2rem 0;

		@include mq($from: medium) {
			padding: 2rem 0 4rem 0;
		}

		&__member-image {
			width: 100%;
			height: auto;

			img {
				width: 100%;
			}
		}
		&__member-title {
			font-family: $fontFamilyBase;
			font-size: 1rem;
			margin-bottom: 0;
			margin-top: 1rem;
			font-weight: 600;
		}
		&__member-desc {
			font-family: $fontFamilyBase;
			font-size: 1rem;
		}
		&__member-email {
			color: $colorHighlight;
			font-size: 1rem;
			text-decoration: none;

			&:hover {
				color: $colorDark;
			}
		}

		&__list {
			display: flex;
			// justify-content: space-between;
			flex-wrap: wrap;

			&-item {
				display: block;
				flex-shrink: 1;
				width: 100%;
				margin-bottom: 2rem;
				text-align: center;

				@include mq($from: medium) {
					width: 33.3%;
					padding-right: 2rem;
					margin-bottom: 3rem;
				}
			}
		}
	}


</style>



// WEBPACK FOOTER //
// Team.vue?d57efc0a